/**
 * Copyright by INSIDE M2M GmbH and the authors 2004 - 2018
 *
 *************************************************************
 ********************* CONFIDENTIAL **************************
 *************************************************************
 *
 */
import { Action } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';
import { apiCallService } from './api-call.service';

/**
 * Helper operator that can be used together with `im2m-common/api-call.service`.
 * This operator catches occuring errors on the observable stream and notifies the `apiCallService` for the given `actionType.`
 *
 * In the error case, this operator will return {@link EMPTY}.
 *
 * @param actionType
 */
export const finalizeApiCall =
    <T extends Action>(actionType: string) =>
    (source: Observable<T>) => {
        return source.pipe(
            catchError((error) => {
                apiCallService.notify({ type: actionType, payload: error }, true);
                return EMPTY;
            }),
            filter((a) => a !== undefined),
            tap((a) => apiCallService.notify({ ...a, type: actionType }))
        );
    };
